import React, { useEffect, useState } from "react";
// import "/assets/css/login.css";
import Helmet from "../../components/Helmet";
import { ClipLoader } from "react-spinners";
import "react-toastify/dist/ReactToastify.css";
import { adminLoginFormValidation } from "../../components/LoginValidation";
import { ToastContainer, toast } from "react-toastify";

import { useNavigate } from "react-router-dom";

import api from "../../api/axiosInstance";

const AdminLogin = () => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };
  const adminLoggedin = async (e) => {
    e.preventDefault();

    const validationErrors = adminLoginFormValidation(formData);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    try {
      setLoading(true);

      const res = await api.post("/adminlogin", formData);

      const { token } = res.data.data;

      localStorage.setItem("token", token);
      navigate("dashboard");
    } catch (error) {
      console.error(error);

      if (error.response?.data?.message) {
        if (error.response?.data?.errors) {
          const apiErrors = {};
          Object.keys(error.response.data.errors).forEach((key) => {
            apiErrors[key] = error.response.data.errors[key].msg;
          });
          setErrors(apiErrors);
          toast.error(error.response.data.message);
          return;
        }
        toast.error(error.response.data.message);
        return;
      }

      toast.error("Something went wrong! Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // 1️⃣ Clear token on login page
    localStorage.removeItem("token");
    localStorage.removeItem("logoutReason");

    // 2️⃣ Existing code: block back button if logged in
    const token = localStorage.getItem("token");
    if (token) {
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = function () {
        window.history.pushState(null, "", window.location.href);
      };
    }

    // 3️⃣ Show logout reason if exists
    const reason = localStorage.getItem("logoutReason");
    if (reason) {
      toast.error(reason);
      setTimeout(() => {
        localStorage.removeItem("logoutReason");
      }, 4000);
    }
  }, []);

  return (
    <div className="login-wrapper">
      <Helmet title="Admin Login" />
      <ToastContainer position="top-center" autoClose={3000} />

      {loading && (
        <div className="full-page-loader">
          <ClipLoader size={60} />
        </div>
      )}

      <div
        className="container  d-flex align-items-center justify-content-center"
        style={{ paddingTop: "5%" }}
      >
        <div className="row w-100 justify-content-center">
          <div className="col-lg-9 col-md-11">
            <div className="card border-0 shadow-lg overflow-hidden login-card">
              <div className="row g-0">
                <div className="col-md-6 d-none d-md-flex login-left">
                  <div className="text-center px-4">
                    <img
                      src="/img/logo.png"
                      alt="University of Delhi Logo"
                      className="login-logo mb-4"
                      style={{ width: "150px" }}
                    />
                    <h1 className="fw-bold mb-3">
                      Financial Support Scheme (FSS)
                    </h1>

                  </div>
                </div>

                {/* RIGHT PANEL */}
                <div className="col-md-6 bg-white">
                  <div className="p-4 p-lg-5">
                    <div className="mb-4 text-center text-md-start">
                      <h3 className="fw-bold">Admin Login</h3>
                      <p className="text-muted">
                        Sign in to access the admin panel
                      </p>
                    </div>

                    <form onSubmit={adminLoggedin}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Employee Code
                        </label>
                        <input
                          type="text"
                          name="email"
                          className={`form-control form-control-lg ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          placeholder="Enter Your Employee Code"
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <div className="invalid-feedback">{errors.email}</div>
                        )}
                      </div>

                      <div className="mb-4">
                        <label className="form-label fw-semibold">
                          Password
                        </label>

                        <div className="position-relative">
                          <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            className={`form-control form-control-lg ${
                              errors.password ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Your Password"
                            onChange={handleChange}
                          />

                          <span
                            onClick={() => setShowPassword(!showPassword)}
                            className="password-toggle"
                          >
                            {showPassword ? "🙈" : "👁️"}
                          </span>
                        </div>

                        {errors.password && (
                          <div className="invalid-feedback d-block">
                            {errors.password}
                          </div>
                        )}
                      </div>

                      <div className="d-grid">
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg fw-bold"
                        >
                          Sign In
                        </button>
                      </div>

                      
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
